export default "__VITE_ASSET__7a37a92e__"